import React, { Component } from 'react';
import PortalPageHeader from '../../common/PortalPageHeader';
import { Box, Card, CardContent, CardMedia, Container, Grid, Typography } from '@mui/material';
import { PageDetails } from '../config';
import SAMFilter from '../SAMFilter';
import { getColumns } from './utils';
import StudentDetails from '../StudentDetails';
import { getData, postData } from '../../../DataAccessLayer';
import { sam } from '../../../DataAccessLayer/services';
import { toast } from 'react-toastify';
import UnassignConfirmation from '../UnassignConfirmation';
import { formatStudents } from '../utils';
import { connect } from 'react-redux';
import { saveIsAutomatedJobCompleted } from '../actions';
import { JobProcessingBanner } from '../JobProcessingBanner';
import { ERROR_CODE } from '../../common/constants';
import { getUser, isUserAdmin, isUserSAMSuperUser } from '../../Layout/utils';
import { JobTriggerCard } from '../JobTriggerCard';

class DifferentMajor extends Component {
  state = {
    id: 'studentsWithDifferentMajor',
    title: '',
    breadcrumbs: [],
    isLoading: false,
    activeDepartment: {},
    students: [],
    isSearchResult: false,
    columns: getColumns(),
    actionMenuItems: [],
    selectedStudents: [],
    isConfirmationPopup: false,
    errorMessage: '',
  };

  async componentDidMount() {
    this.loadPageTitle();
    this.loadBreadcrumbs();
    this.loadActionMenuItems();
  }

  //θ(1) Toggles isLoading
  toggleIsLoading = (isLoading = !this.state.isLoading) => {
    this.setState({
      isLoading,
    });
  };

  //θ(1) Toggles isSearchResult
  toggleIsSearchResult = (isSearchResult = !this.state.isSearchResult) => {
    this.setState({
      isSearchResult,
    });
  };

  //θ(1) Toggles isConfirmationPopup
  toggleIsConfirmationPopup = (isConfirmationPopup = !this.state.isConfirmationPopup) => {
    this.setState({
      isConfirmationPopup,
    });
  };

  //θ(N) where N is the number of pages in PageDetails
  //Retrieve page title from pageDetails using pageid
  loadPageTitle = () => {
    const page = Object.values(PageDetails).find((page) => page.id === this.state.id);
    this.setState({
      title: page.title,
    });
  };

  loadBreadcrumbs = () => {
    const page = Object.values(PageDetails).find((page) => page.id === this.state.id);
    this.setState({
      breadcrumbs: page.breadcrumbs,
    });
  };

  //θ(1) Sets action menu items
  loadActionMenuItems = () => {
    const { id } = this.state;

    const actionMenuItems = [
      {
        id: `${id}__menuItem_removeAdvsior`,
        label: 'Remove Advisor',
        onClick: this.toggleIsConfirmationPopup,
      },
    ];

    this.setState({
      actionMenuItems,
    });
  };

  //θ(1) Sets the selected students from datagrid
  onStudentSelected = (selectedStudents) => {
    this.setState({
      selectedStudents,
    });
  };

  //θ(1) Search students for seleted advisors
  //TODO add code to call search api
  searchStudents = (selectedValues) => {
    //Set searched department as selected department as users may change department while UI showing data of previous department
    const { department } = selectedValues;
    this.setState({
      activeDepartment: department,
      students: [],
    });
    this.toggleIsSearchResult(true);
    this.loadStudents(department);
  };

  //θ(1) Loads students for selected department
  loadStudents = (department = this.state.activeDepartment) => {
    this.toggleIsLoading(true);
    this.setState({
      students: [],
    });
    const departmentCode = department.STVDEPT_CODE;
    getData(sam.differentMajor(departmentCode), true)
      .then((students) => {
        students = formatStudents(students);
        this.setState({
          students,
          errorMessage: '',
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          errorMessage:
            'We’re currently experiencing an issue retrieving student data. Please try again later.',
        });
      })
      .finally((_) => {
        this.toggleIsLoading(false);
      });
  };

  //θ(1) Unassign selected students
  unassignStudents = () => {
    this.toggleIsLoading(true);

    const selectedStudents = this.state.selectedStudents.map((student) => student.split('_')[0]);

    const body = {
      studentPidms: selectedStudents,
    };

    const studentMessage = this.state.selectedStudents.length > 1 ? 'Students' : 'Student';

    postData(sam.unassignStudents, body, true)
      .then((result) => {
        toast.success(`${studentMessage} Removed from Advisor`);
        this.toggleIsLoading(false);
        this.toggleIsConfirmationPopup(false);
        this.loadStudents();
      })
      .catch((err) => {
        console.log(err);
        // In the backend we check if the auto job is running or not
        // It will return 400 Bad request if the job is runnning so we can handle it in the FE
        if (err.status === ERROR_CODE.BAD_REQUEST) {
          this.props.saveIsAutomatedJobCompleted(false);
        }
        toast.error(`Unable to Remove ${studentMessage} from Advisor`);
        this.toggleIsLoading(false);
      });
  };

  render() {
    const { id } = this.state;
    const studentMessage = this.state.selectedStudents.length > 1 ? 'Students' : 'Student';
    const { isAutomatedJobCompleted, isCheckingAutomatedJobStatus } = this.props;
    const user = getUser(this.props.user, this.props.impersonation);
    const isSamSuperUserUp = isUserAdmin(user) || isUserSAMSuperUser(user);

    return (
      <React.Fragment>
        <div id={`${id}__div_pageWrapper`} className={`myOdu__${id} myOdu__sam`}>
          <Container id={`${id}__container_pageWrapper`} className="myOdu__container secondaryPage">
            <PortalPageHeader
              id={this.state.id}
              title={this.state.title}
              breadcrumbs={this.state.breadcrumbs}
              banner={<JobProcessingBanner />}
            />

            <Box id={`${id}__box_wrapper`} className={'wrapper'}>
              <UnassignConfirmation
                maxWidth="sm"
                onClose={() => {
                  this.toggleIsConfirmationPopup(false);
                }}
                isOpen={this.state.isConfirmationPopup}
                primaryButtonTitle="unassign"
                onPrimaryClick={this.unassignStudents}
                isPrimaryButtonDisabled={this.state.isLoading}
                secondaryButtonTitle="cancel"
                onSecondaryClick={() => {
                  this.toggleIsConfirmationPopup(false);
                }}
                isCloseable={true}
                title={`Unassign Selected ${studentMessage}`}
                message={`Are you sure you want to unassign selected ${studentMessage.toLowerCase()}? This action cannot be undone.`}
              />

              <Grid container gap={2} alignItems="start" justifyContent="center">
                <Grid item className="actionOption">
                  <Card elevation={0}>
                    <CardMedia
                      className="media"
                      component="img"
                      image="/img/binoculars.svg"
                      alt="person using binoculars"
                    />
                    <Typography component="h3" align="center">
                      View Students With Different Major
                    </Typography>
                    <CardContent>
                      <SAMFilter
                        id={id}
                        isDepartmentCode
                        isDepartmentRequired
                        departmentsLength={{
                          xs: 12,
                          xl: 9,
                        }}
                        primaryButtonText={'Search'}
                        onPrimary={this.searchStudents}
                        disablePrimaryButton={this.state.isLoading}
                        primaryButtonLength={{
                          xs: 12,
                          xl: 1,
                        }}
                        widgetName={this.state.title}
                      />
                    </CardContent>
                  </Card>
                </Grid>
                {isSamSuperUserUp && (
                  <Grid item className="actionOption">
                    <JobTriggerCard
                      id="diffMajorAutoUnassignmentJob"
                      jobName="Different Major Students Unassignment"
                      action="Unassign Students With Different
                                                Major"
                      triggerFunction={() => sam.batch().diffMajor.unassign}
                    />
                  </Grid>
                )}
              </Grid>

              {this.state.isSearchResult && (
                <StudentDetails
                  id={`${id}Details`}
                  students={this.state.students}
                  columns={this.state.columns}
                  onStudentSelected={this.onStudentSelected}
                  actionMenuItems={this.state.actionMenuItems}
                  disableActionButton={
                    this.state.selectedStudents.length === 0 ||
                    !isAutomatedJobCompleted ||
                    isCheckingAutomatedJobStatus
                  }
                  noStudentMessage={
                    this.state.errorMessage.length ? (
                      this.state.errorMessage
                    ) : (
                      <>
                        There are no students with different major in{' '}
                        <strong>{this.state.activeDepartment.STVDEPT_DESC}</strong>.
                      </>
                    )
                  }
                  message={`Students with Different Major in ${this.state.activeDepartment.STVDEPT_DESC}`}
                  isLoading={this.state.isLoading}
                />
              )}
            </Box>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.AWSReducer.user,
    impersonation: state.impersonationReducer.impersonation,
    isAutomatedJobCompleted: state.samReducer.isAutomatedJobCompleted,
    isCheckingAutomatedJobStatus: state.samReducer.isCheckingAutomatedJobStatus,
  };
};

const mapDispatchToProps = (dispatch) => ({
  saveIsAutomatedJobCompleted: (isAutomatedJobCompleted) =>
    dispatch(saveIsAutomatedJobCompleted(isAutomatedJobCompleted)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DifferentMajor);
